import { Box, CardContent, CardMedia, Typography } from '@mui/material';
import React from 'react';
import './Works.css';

const Works = (props) => {
    const { name, img, describe } = props.work;
    return (
        <div>
            <Box sx={{ my: 5 }}>
                <CardMedia
                    component="img"
                    style={{ width: '95%', margin: 'auto' }}
                    image={img}
                    alt="green iguana"
                />
                <CardContent sx={{ textAlign: 'left' }}>
                    <Typography sx={{ fontWeight: 600, color: '#000D83', py: 1 }} id="card-name" variant="h5" component="div">
                        {name}
                    </Typography>
                    <Typography sx={{ fontWeight: 400, color: '#5B5B5B', fontSize: '18px' }} id="card-description" variant="body3" component="div">
                        {describe}
                    </Typography>
                </CardContent>
            </Box>
        </div>
    );
};

export default Works;